@for (each of data; track each?.betId) {
  <app-ub-update-form [initialData]="each" [betMarkets]="betMarkets" [matchType]="context" />
}
